<template>
  <v-app>
    <v-app-bar
      fixed
      dense
      flat
      min-height="45px"
      style="
        font-family:
          'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
        background: black;
      "
      max-height="45px"
      id="topLogIn"
    >
      <!-- style="font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif" -->
      <v-toolbar-title>
        <v-card
          class="transparent"
          min-height="40px"
          max-height="40px"
          min-width="90px"
          max-width="90px"
        >
          <v-img src="AGTSLogo.png"></v-img> </v-card
      ></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text to="/login"> login </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-main>
      <v-container fluid class="fill-height"> </v-container>
    </v-main>
    <v-footer app padless>
      <v-card flat tile width="100%" color="#0e5c95">
        <v-divider></v-divider>
        <v-card-text class="text-center">
          {{ new Date().getFullYear() }} — Powered By:<strong> TACOai</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'StartLayout',
  created() {
    this.$router.push('/login')
  },
}
</script>
